var _font, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidTermo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 245",
    enableBackground: "new 0 0 1080 245",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _font || (_font = /*#__PURE__*/React.createElement("font", {
    horizAdvX: 1000
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FreightMacroProSemibold-Regular",
    unitsPerEm: 1000,
    underlinePosition: -133,
    underlineThickness: 20
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 496,
    d: "M426,0l0,624l-356,0l0,-624M106,88l0,449l121,-225M248,350l-131,239l261,0M378,36l-261,0l131,239M390,88l-122,224l122,225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 524,
    d: "M375,334C443,361 480,410 480,477C480,582 405,639 263,639C121,639 45,569 45,463C45,396 87,343 149,317l0,-8C75,285 31,226 31,156C31,48 107,-14 260,-14C419,-14 493,64 493,168C493,247 449,296 375,326M382,166C382,114 350,72 263,72C185,72 139,104 139,173C139,220 162,259 218,287C346,254 382,229 382,166M305,353C188,383 156,410 156,468C156,516 185,553 261,553C341,553 372,521 372,458C372,414 348,382 305,353z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 444,
    d: "M414,389l0,93l-322,0l-51,-300l64,-16C250,130 309,79 309,-2C309,-79 271,-118 191,-118C142,-118 120,-104 120,-78C120,-74 121,-62 121,-56C121,-35 110,-22 67,-22C19,-22 12,-40 12,-65C12,-144 62,-204 193,-204C328,-204 419,-117 419,5C419,100 361,202 147,255l23,134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 519,
    d: "M421,-190l0,190l90,0l0,87l-90,0l0,399l-96,0l-306,-414l8,-72l291,0l0,-190M318,87l-191,0l181,254l10,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 531,
    d: "M96,-195C360,-135 500,32 500,251C500,381 414,496 270,496C118,496 31,400 31,266C31,137 109,58 226,58C276,58 323,77 369,116l5,-5C323,-6 223,-77 75,-116M383,194C348,160 308,145 261,145C181,145 142,194 142,277C142,357 186,409 260,409C335,409 393,350 393,265C393,240 389,213 383,194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 377,
    d: "M353,0l0,87l-98,0l-2,4l0,398l-230,-42l0,-94l126,23l0,-285l-2,-4l-101,0l0,-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 811,
    d: "M185,-15l524,656l-85,0l-520,-656M189,302C301,302 364,370 364,484C364,588 309,654 200,654C88,654 25,586 25,472C25,368 79,302 189,302M197,370C135,370 109,403 109,481C109,542 137,586 192,586C254,586 280,554 280,476C280,415 252,370 197,370M612,-29C724,-29 786,38 786,152C786,256 732,322 623,322C511,322 448,254 448,140C448,36 502,-29 612,-29M622,38C560,38 534,70 534,149C534,209 562,254 617,254C678,254 704,222 704,143C704,83 677,38 622,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 250,
    d: "M205,66C205,116 177,144 125,144C72,144 44,116 44,65C44,14 72,-13 125,-13C177,-13 205,15 205,66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 520,
    d: "M196,-190l295,588l-8,84l-431,0l-22,-191l77,0l36,105l243,0l0,-11l-300,-575z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 531,
    d: "M158,371C210,486 308,551 456,590l-21,79C171,609 31,446 31,229C31,99 117,-14 261,-14C413,-14 500,82 500,216C500,345 422,424 305,424C255,424 209,405 163,366M389,205C389,125 345,73 271,73C196,73 138,132 138,217C138,242 142,269 148,288C183,322 223,337 270,337C350,337 389,288 389,205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 464,
    d: "M227,173C365,231 416,284 416,363C416,432 371,496 248,496C172,496 97,478 28,435l0,-94C90,381 162,408 220,408C281,408 304,380 304,342C304,286 250,241 87,169l11,-89C133,87 171,91 201,91C301,91 331,56 331,0C331,-74 288,-118 194,-118C135,-118 117,-103 117,-78C117,-74 118,-61 118,-56C118,-35 107,-22 64,-22C16,-22 9,-40 9,-65C9,-145 55,-204 195,-204C352,-204 442,-110 442,9C442,115 374,167 277,167C263,167 244,165 227,163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 489,
    d: "M444,0l20,173l-75,0l-29,-87l-209,0l0,10l113,63C378,224 427,274 427,359C427,428 375,496 254,496C183,496 99,477 35,435l0,-94C95,381 172,408 226,408C287,408 315,380 315,341C315,296 274,259 174,196l-141,-90l10,-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 537,
    d: "M31,226C31,73 116,-14 259,-14C423,-14 506,89 506,256C506,409 421,496 279,496C117,496 31,393 31,226M395,242C395,128 351,73 268,73C184,73 142,130 142,240C142,353 187,409 271,409C355,409 395,352 395,242z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.66,
    y: 49.73,
    fill: "#F1C500",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.8862 194.0591)",
    fill: "#F1C500",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "4.5%"), /*#__PURE__*/React.createElement("rect", {
    x: 49.54,
    y: 78.59,
    fill: "#F2C400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.42,
    y: 78.59,
    fill: "#F3C200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 78.59,
    fill: "#F4C100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.17,
    y: 78.59,
    fill: "#F5BF00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.05,
    y: 78.59,
    fill: "#F6BE00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.93,
    y: 78.59,
    fill: "#F7BC00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.81,
    y: 78.59,
    fill: "#F8BB00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.68,
    y: 78.59,
    fill: "#F9B900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.56,
    y: 78.59,
    fill: "#FAB800",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 49.73,
    fill: "#FBB600",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 116.6616 194.0591)",
    fill: "#FBB600",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "5.7%"), /*#__PURE__*/React.createElement("rect", {
    x: 148.32,
    y: 78.59,
    fill: "#FCB500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.19,
    y: 78.59,
    fill: "#FDB300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.07,
    y: 78.59,
    fill: "#FEB200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.95,
    y: 78.59,
    fill: "#FEB000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.83,
    y: 78.59,
    fill: "#FFAF00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.7,
    y: 78.59,
    fill: "#FFAD00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.58,
    y: 78.59,
    fill: "#FFAC00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.46,
    y: 78.59,
    fill: "#FFAA00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.33,
    y: 78.59,
    fill: "#FFA900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.21,
    y: 49.73,
    fill: "#FFA700",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 215.436 194.0591)",
    fill: "#FFA700",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "6.9%"), /*#__PURE__*/React.createElement("rect", {
    x: 247.09,
    y: 78.59,
    fill: "#FFA600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.97,
    y: 78.59,
    fill: "#FFA400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.84,
    y: 78.59,
    fill: "#FFA300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.72,
    y: 78.59,
    fill: "#FFA100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.6,
    y: 78.59,
    fill: "#FFA000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.48,
    y: 78.59,
    fill: "#FF9E00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.35,
    y: 78.59,
    fill: "#FF9C00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.23,
    y: 78.59,
    fill: "#FF9B00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.11,
    y: 78.59,
    fill: "#FF9900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.99,
    y: 49.73,
    fill: "#FF9800",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 314.2104 194.0591)",
    fill: "#FF9800",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "8.1%"), /*#__PURE__*/React.createElement("rect", {
    x: 345.86,
    y: 78.59,
    fill: "#FF9600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.74,
    y: 78.59,
    fill: "#FF9500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.62,
    y: 78.59,
    fill: "#FF9300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.5,
    y: 78.59,
    fill: "#FF9200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.37,
    y: 78.59,
    fill: "#FF9000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.25,
    y: 78.59,
    fill: "#FF8F00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.13,
    y: 78.59,
    fill: "#FF8D00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 78.59,
    fill: "#FF8C00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.88,
    y: 78.59,
    fill: "#FF8A00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.76,
    y: 49.73,
    fill: "#FF8900",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 412.9849 194.0591)",
    fill: "#FF8900",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "9.3%"), /*#__PURE__*/React.createElement("rect", {
    x: 444.64,
    y: 78.59,
    fill: "#FF8700",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.52,
    y: 78.59,
    fill: "#FF8600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.39,
    y: 78.59,
    fill: "#FF8400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.27,
    y: 78.59,
    fill: "#FF8300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.15,
    y: 78.59,
    fill: "#FF8100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.03,
    y: 78.59,
    fill: "#FF8000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.9,
    y: 78.59,
    fill: "#FF7E00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.78,
    y: 78.59,
    fill: "#FF7D00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.66,
    y: 78.59,
    fill: "#FF7B00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.54,
    y: 49.73,
    fill: "#FF7A00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.9858 194.0591)",
    fill: "#FF7A00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "10.5%"), /*#__PURE__*/React.createElement("rect", {
    x: 543.41,
    y: 78.59,
    fill: "#FF7800",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.29,
    y: 78.59,
    fill: "#FF7700",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.17,
    y: 78.59,
    fill: "#FF7500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.05,
    y: 78.59,
    fill: "#FF7400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.92,
    y: 78.59,
    fill: "#FF7200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.8,
    y: 78.59,
    fill: "#FF7100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.68,
    y: 78.59,
    fill: "#FF6F00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.56,
    y: 78.59,
    fill: "#FF6E00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.43,
    y: 78.59,
    fill: "#FF6C00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.31,
    y: 49.73,
    fill: "#FF6B00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 604.7598 194.0591)",
    fill: "#FF6B00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "11.7%"), /*#__PURE__*/React.createElement("rect", {
    x: 642.19,
    y: 78.59,
    fill: "#FF6900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.06,
    y: 78.59,
    fill: "#FF6800",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.94,
    y: 78.59,
    fill: "#FF6600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.82,
    y: 78.59,
    fill: "#FF6500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.7,
    y: 78.59,
    fill: "#FF6300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.57,
    y: 78.59,
    fill: "#FF6100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.45,
    y: 78.59,
    fill: "#FF6000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 78.59,
    fill: "#FF5E00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.21,
    y: 78.59,
    fill: "#FF5D00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731.08,
    y: 49.73,
    fill: "#FF5B00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 703.5352 194.0591)",
    fill: "#FF5B00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "12.9%"), /*#__PURE__*/React.createElement("rect", {
    x: 740.96,
    y: 78.59,
    fill: "#FF5A00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.84,
    y: 78.59,
    fill: "#FF5800",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760.72,
    y: 78.59,
    fill: "#FF5700",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770.59,
    y: 78.59,
    fill: "#FF5500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780.47,
    y: 78.59,
    fill: "#FF5400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790.35,
    y: 78.59,
    fill: "#FF5200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.23,
    y: 78.59,
    fill: "#FF5100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.1,
    y: 78.59,
    fill: "#FF4F00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.98,
    y: 78.59,
    fill: "#FF4E00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.86,
    y: 49.73,
    fill: "#FF4C00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 802.3086 194.0591)",
    fill: "#FF4C00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "14.1%"), /*#__PURE__*/React.createElement("rect", {
    x: 839.74,
    y: 78.59,
    fill: "#FF4B00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.61,
    y: 78.59,
    fill: "#FF4900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 859.49,
    y: 78.59,
    fill: "#FF4800",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.37,
    y: 78.59,
    fill: "#FF4600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.25,
    y: 78.59,
    fill: "#FF4500",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 889.12,
    y: 78.59,
    fill: "#FF4300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 78.59,
    fill: "#FF4200",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 908.88,
    y: 78.59,
    fill: "#FF4000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.76,
    y: 78.59,
    fill: "#FF3F00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.63,
    y: 49.73,
    fill: "#FF3D00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 901.084 194.0591)",
    fill: "#FF3D00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "15.3%"), /*#__PURE__*/React.createElement("rect", {
    x: 938.51,
    y: 78.59,
    fill: "#FF3C00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.39,
    y: 78.59,
    fill: "#FF3A00",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 958.27,
    y: 78.59,
    fill: "#FF3900",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 968.14,
    y: 78.59,
    fill: "#FF3700",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.02,
    y: 78.59,
    fill: "#FF3600",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.9,
    y: 78.59,
    fill: "#FF3400",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997.77,
    y: 78.59,
    fill: "#FF3300",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1007.65,
    y: 78.59,
    fill: "#FF3100",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.53,
    y: 78.59,
    fill: "#FF3000",
    width: 4.04,
    height: 57.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.41,
    y: 49.73,
    fill: "#FF2E00",
    width: 4.04,
    height: 115.47
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 999.8574 194.0591)",
    fill: "#FF2E00",
    fontFamily: "'FreightMacroProSemibold-Regular'",
    fontSize: "23.0931px"
  }, "16.5%"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidTermo);
export default __webpack_public_path__ + "static/media/CovidTermo.363466a53df8e1a348c93db7f3f7c21c.svg";
export { ForwardRef as ReactComponent };